import AiSecurityExperience from '@comp/ai/ai-security-experience'

export default function McpGatewayPage({ locale }: { locale: string }) {
  return <AiSecurityExperience page="gateway" locale={locale} />
}

export async function getStaticProps({ locale }: { locale: string }) {
  return { props: { locale: locale ?? 'en' } }
}
